export default __webpack_public_path__ + "static/media/clarity-fl.a0fc24f4.webp";